<script>
  import BaseContentSet from '../BaseContentSet/BaseContentSet.svelte';
  import { getPath } from '../../utils/imageKit.ts';

  let {
    baseContent,
    backgroundImage,
    alignment = 'left',
    theme = 'pink',
    lazyloadImage = true,
    lang,
    dataTestId = 'marketing-colored-background',
  } = $props();

  // Handle Image Setup
  const smSrc = getPath(backgroundImage, { w: 280 });
  const mdSrc = getPath(backgroundImage, { w: 610 });
  const lgSrc = getPath(backgroundImage, { w: 1024 });
  const xlSrc = getPath(backgroundImage, { w: 1220 });
</script>

<div data-testid={dataTestId} class="max-w-6xl mx-auto my-7 lg:my-10">
  <div
    class="flex flex-col lg:min-h-112 mx-4"
    class:lg:flex-row={alignment == 'left'}
    class:lg:flex-row-reverse={alignment == 'right'}
    class:bg-pink={theme == 'pink'}
    class:bg-yellow-desert={theme == 'yellow'}
    class:bg-blue-dark-gray={theme == 'blue'}
  >
    <div class="flex w-full lg:w-1/2 px-8 lg:p-14 justify-center items-center">
      {#if backgroundImage && backgroundImage.url && backgroundImage.alt}
        <img
          class="object-contain h-full w-full m-8"
          loading={lazyloadImage === true ? 'lazy' : 'eager'}
          src={smSrc}
          alt={backgroundImage.alt}
          srcset={`${smSrc} 280w, ${mdSrc} 610w, ${lgSrc} 1024w, ${xlSrc} 1220w`}
          width="279"
          height="186"
          sizes="(min-width 640px) 529px, (min-width: 768px) 657px, (min-width: 1024px) 380px, (min-width: 1280px)
          460px, 80vw"
        />
      {/if}
    </div>
    <BaseContentSet
      {...baseContent}
      lang={lang || 'en'}
      className={`p-8 lg:p-12 lg:w-1/2 flex flex-col justify-center bg-white mt-0 mx-2 mb-2 lg:mt-2 ${
        alignment === 'left' ? 'lg:ml-0' : 'lg:mr-0'
      } ${!backgroundImage.url ? 'mt-2' : ''}`}
    />
  </div>
</div>
